import React from 'react';
import {Route} from 'react-router-dom';
import AsyncList from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <Route
    key="/business/successstory/list"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Success Story List',
            item: '/business/successstory/list',
          },
        ]}
      />
    }
  >
    <Route path="business/successstory/list" element={<AsyncList />} />
  </Route>,
  <Route key="/business/iframe/successstory/list" element={<BlankLayout />}>
    <Route path="business/iframe/successstory/list" element={<AsyncList />} />
  </Route>,
];
